import type { Routes } from '@angular/router';
import { environment } from '@app/environment';

export const appRoutes: Routes = [
  {
    loadComponent: () =>
      import('@app/pages/photobooth').then((m) => m.PhotoboothComponent),
    path: 'photobooth',
    title: 'Фотобудка',
  },
  {
    loadComponent: () =>
      import('./layout.component').then((c) => c.LayoutComponent),
    path: '',
    children: [
      {
        loadComponent: () =>
          import('@app/pages/main').then((m) => m.MainComponent),
        path: '',
        data: {
          reuse: true,
        },
      },
      {
        loadComponent: () =>
          import('@app/pages/program').then((m) => m.ProgramComponent),
        path: 'program',
        title: 'Программа',
      },
      {
        loadComponent: () =>
          import('@app/pages/experts-all').then((m) => m.ExpertsAllComponent),
        path: 'experts',
        title: 'Эксперты',
      },
      {
        loadComponent: () =>
          import('@app/pages/expert').then((m) => m.ExpertComponent),
        path: 'experts/:id',
        title: 'Лучшие шеф-повара на ЗАВТРАк ШЕФА',
      },
      {
        loadComponent: () =>
          import('@app/pages/photo-gallery').then(
            (m) => m.PhotoGalleryComponent,
          ),
        path: 'gallery',
        title: 'Фотогалерея',
      },
      {
        loadComponent: () =>
          import('@app/pages/news').then((m) => m.NewsComponent),
        path: 'news',
        title: 'Новости',
      },
      {
        loadComponent: () =>
          import('@app/pages/for-companies').then((m) => m.ForCompanies),
        path: 'for-companies',
        title: 'Партнёрам и спонсорам',
      },
      ...(environment.ticketsEnabled
        ? [
            {
              loadComponent: () =>
                import('@app/pages/get-promo-ticket').then(
                  (m) => m.GetPromoTicket,
                ),
              path: 'get-ticket',
              title: 'Получить промо-билет',
            },
          ]
        : []),
      {
        redirectTo: '',
        path: '**',
      },
    ],
  },
];
